import { c as _c } from "react/compiler-runtime";
import { Icon, IconSize } from '@/components/Atoms/Icon/Icon';
import { IndicatorBadge } from '@/components/Atoms/IndicatorBadge/IndicatorBadge';
import { NeutralLink } from '@/components/Atoms/Neutral/Neutral';
import Close from '@/components/Icons/Close';
import Menu from '@/components/Icons/Menu';
import { AccountMenuList } from '@/components/Organisms/Navigation/AccountMenu/AccountMenuList';
import { NavigationLink } from '@/components/Organisms/Navigation/Desktop/NavigationLink';
import { MenuOverlay, NavigationPanel } from '@/components/Organisms/Navigation/Desktop/NavigationPanel';
import { QUICK_SEARCH_INPUT_ID } from '@/components/Organisms/Navigation/Desktop/QuickSearch/QuickSearch';
import { QuickSearchPanel } from '@/components/Organisms/Navigation/Desktop/QuickSearchPanel';
import { PageContainer } from '@/components/Templates/PageContainer/PageContainer';
import { useNavigationContext } from '@/contexts/NavigationContext/NavigationContext';
import { ACCOUNT_MENU_ID, MENU_ID } from '@/contexts/NavigationContext/NavigationWrapper';
import useTranslation from '@/hooks/useTranslation';
import { TourTargets } from '@/interfaces';
import { buildTrackingObject } from '@/services/Analytics/bbAnalyticsTrackers';
import { TrackingAction, TrackingCategory } from '@/services/Analytics/bnefAnalyticsSettings';
import { toast } from '@/services/Toast/toastStore';
import SavedStatesScheduler from '@/services/UserActivity/SavedStatesScheduler';
import classNames from '@/utils/classNames';
import MagnifyIcon from '@bloomberg/web-icons-react/Magnify';
import User from '@bloomberg/web-icons-react/User';
import type { KeyboardEvent, MouseEvent } from 'react';
import { useEffect } from 'react';
import { Logo } from '../Logo';
import styles from './NavigationBar.module.css';
export const NavigationBar = () => {
  const $ = _c(73);
  const {
    t
  } = useTranslation();
  const {
    navSections,
    notificationBadge,
    modifySavedItemCount,
    isMenuOpen,
    toggleMenu,
    closeMenu,
    isAccountMenuOpen,
    openAccountMenu,
    visibleHoverMenuIndex,
    isDesktopQuickSearchVisible,
    openQuickSearch
  } = useNavigationContext();
  let t0;
  if ($[0] !== modifySavedItemCount || $[1] !== t) {
    t0 = () => SavedStatesScheduler.getInstance().subscribeToChanges(t1 => {
      const {
        value
      } = t1;
      if (value) {
        modifySavedItemCount(1);
        toast.success(t("common:Navigation.saved_notification"));
      } else {
        modifySavedItemCount(-1);
      }
    });
    $[0] = modifySavedItemCount;
    $[1] = t;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  useEffect(t0, t1);
  let t2;
  if ($[4] !== closeMenu) {
    t2 = () => {
      const areas = document.querySelectorAll("main, footer");
      document.body.addEventListener("mouseleave", closeMenu);
      for (let i = 0; i < areas.length; i++) {
        areas[i].addEventListener("mouseenter", closeMenu);
      }
      return () => {
        document.body.removeEventListener("mouseleave", closeMenu);
        for (let i_0 = 0; i_0 < areas.length; i_0++) {
          areas[i_0].removeEventListener("mouseenter", closeMenu);
        }
      };
    };
    $[4] = closeMenu;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = [];
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  useEffect(t2, t3);
  let t4;
  if ($[7] !== t) {
    t4 = t("common:SiteSection.main_menu");
    $[7] = t;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== toggleMenu) {
    t5 = event => {
      event.preventDefault();
      toggleMenu();
      window.scrollTo(0, 0);
    };
    $[9] = toggleMenu;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== isMenuOpen) {
    t6 = <Icon use={isMenuOpen ? <Close /> : <Menu />} />;
    $[11] = isMenuOpen;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t4 || $[14] !== t5 || $[15] !== t6) {
    t7 = <NeutralLink className={styles.menuIconButton} href={`#${MENU_ID}`} title={t4} onClick={t5}>{t6}</NeutralLink>;
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = buildTrackingObject(TrackingAction.Click, TrackingCategory.Navigation, "Navigation: Logo");
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== closeMenu) {
    t9 = <Logo id="logo" data-navigation-id="navigation:logo" data-analytics-tracking={t8} onMouseOver={closeMenu} />;
    $[18] = closeMenu;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== navSections || $[21] !== visibleHoverMenuIndex) {
    let t11;
    if ($[23] !== visibleHoverMenuIndex) {
      t11 = (x, i_1) => <li key={i_1}><NavigationLink section={x} index={i_1} />{visibleHoverMenuIndex === i_1 && <NavigationPanel />}</li>;
      $[23] = visibleHoverMenuIndex;
      $[24] = t11;
    } else {
      t11 = $[24];
    }
    t10 = navSections.map(t11);
    $[20] = navSections;
    $[21] = visibleHoverMenuIndex;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[25] !== t10) {
    t11 = <ul className={styles.inlineMenu}>{t10}</ul>;
    $[25] = t10;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  const t12 = isDesktopQuickSearchVisible && styles.selected;
  let t13;
  if ($[27] !== t12) {
    t13 = classNames(styles.navIconLink, t12);
    $[27] = t12;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  let t14;
  if ($[29] !== openQuickSearch) {
    t14 = () => {
      openQuickSearch();
    };
    $[29] = openQuickSearch;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  let t15;
  if ($[31] !== t) {
    t15 = t("common:SiteSection.search");
    $[31] = t;
    $[32] = t15;
  } else {
    t15 = $[32];
  }
  let t16;
  if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <Icon use={<MagnifyIcon />} />;
    $[33] = t16;
  } else {
    t16 = $[33];
  }
  let t17;
  if ($[34] !== t13 || $[35] !== t14 || $[36] !== t15) {
    t17 = <NeutralLink className={t13} href="/search" data-tour={TourTargets.navSearchIcon} onMouseEnter={t14} onClick={_temp2} title={t15}>{t16}</NeutralLink>;
    $[34] = t13;
    $[35] = t14;
    $[36] = t15;
    $[37] = t17;
  } else {
    t17 = $[37];
  }
  let t18;
  if ($[38] !== isAccountMenuOpen) {
    t18 = classNames(styles.navIconLink, {
      [styles.selected]: isAccountMenuOpen
    });
    $[38] = isAccountMenuOpen;
    $[39] = t18;
  } else {
    t18 = $[39];
  }
  let t19;
  if ($[40] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = buildTrackingObject(TrackingAction.Click, TrackingCategory.Navigation, "Navigation: AccountIconButton");
    $[40] = t19;
  } else {
    t19 = $[40];
  }
  let t20;
  if ($[41] !== t) {
    t20 = t("common:Common.account");
    $[41] = t;
    $[42] = t20;
  } else {
    t20 = $[42];
  }
  let t21;
  if ($[43] !== closeMenu || $[44] !== isAccountMenuOpen || $[45] !== openAccountMenu) {
    t21 = event_1 => {
      event_1.preventDefault();
      if (isAccountMenuOpen) {
        closeMenu();
      } else {
        openAccountMenu();
      }
    };
    $[43] = closeMenu;
    $[44] = isAccountMenuOpen;
    $[45] = openAccountMenu;
    $[46] = t21;
  } else {
    t21 = $[46];
  }
  let t22;
  if ($[47] !== closeMenu) {
    t22 = event_2 => {
      if (event_2.key === "Escape") {
        closeMenu();
      }
    };
    $[47] = closeMenu;
    $[48] = t22;
  } else {
    t22 = $[48];
  }
  let t23;
  if ($[49] !== t) {
    t23 = t("common:Common.account");
    $[49] = t;
    $[50] = t23;
  } else {
    t23 = $[50];
  }
  let t24;
  if ($[51] === Symbol.for("react.memo_cache_sentinel")) {
    t24 = <Icon use={<User />} size={IconSize.EXTRA_SMALL} />;
    $[51] = t24;
  } else {
    t24 = $[51];
  }
  let t25;
  if ($[52] !== notificationBadge) {
    t25 = notificationBadge?.totalCount ? <IndicatorBadge className={styles.profileIndicatorBadge}>{notificationBadge.totalCount}</IndicatorBadge> : null;
    $[52] = notificationBadge;
    $[53] = t25;
  } else {
    t25 = $[53];
  }
  let t26;
  if ($[54] !== isAccountMenuOpen || $[55] !== openAccountMenu || $[56] !== t18 || $[57] !== t20 || $[58] !== t21 || $[59] !== t22 || $[60] !== t23 || $[61] !== t25) {
    t26 = <NeutralLink className={t18} href={`#${ACCOUNT_MENU_ID}`} data-navigation-id="navigation:accountIconButton" data-analytics-tracking={t19} title={t20} onMouseEnter={openAccountMenu} onClick={t21} onKeyDown={t22} aria-label={t23} aria-expanded={isAccountMenuOpen}>{t24}{t25}</NeutralLink>;
    $[54] = isAccountMenuOpen;
    $[55] = openAccountMenu;
    $[56] = t18;
    $[57] = t20;
    $[58] = t21;
    $[59] = t22;
    $[60] = t23;
    $[61] = t25;
    $[62] = t26;
  } else {
    t26 = $[62];
  }
  let t27;
  if ($[63] !== t11 || $[64] !== t17 || $[65] !== t26 || $[66] !== t7 || $[67] !== t9) {
    t27 = <div className={styles.bar}>{t7}{t9}{t11}{t17}{t26}</div>;
    $[63] = t11;
    $[64] = t17;
    $[65] = t26;
    $[66] = t7;
    $[67] = t9;
    $[68] = t27;
  } else {
    t27 = $[68];
  }
  let t28;
  let t29;
  if ($[69] === Symbol.for("react.memo_cache_sentinel")) {
    t28 = <QuickSearchPanel />;
    t29 = <AccountMenu />;
    $[69] = t28;
    $[70] = t29;
  } else {
    t28 = $[69];
    t29 = $[70];
  }
  let t30;
  if ($[71] !== t27) {
    t30 = <nav aria-label="main">{t27}{t28}{t29}</nav>;
    $[71] = t27;
    $[72] = t30;
  } else {
    t30 = $[72];
  }
  return t30;
};
const AccountMenu = () => {
  const $ = _c(2);
  const {
    isAccountMenuOpen
  } = useNavigationContext();
  if (!isAccountMenuOpen) {
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t0 = <></>;
      $[0] = t0;
    } else {
      t0 = $[0];
    }
    return t0;
  }
  let t0;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <MenuOverlay><PageContainer><AccountMenuList className={styles.accountMenuList} /></PageContainer></MenuOverlay>;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};
function _temp() {
  const input = document.getElementById(QUICK_SEARCH_INPUT_ID);
  if (input) {
    input.focus();
  }
}
function _temp2(event_0) {
  event_0.preventDefault();
  requestAnimationFrame(_temp);
}